/* eslint-disable react/no-array-index-key */
import React, { useCallback, useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { RiAddFill, RiBuilding2Fill } from "react-icons/ri";
import { PrimaryButton } from "screens/perfilAutonomo/components/primaryButton.component";
import { SecondaryButton } from "screens/perfilAutonomo/components/secondaryButton.component";
import { DefaultButton } from "screens/perfilAutonomo/components/defaultButton.component";
import SelectComponent from "components/selectAutoCompleteG";
import { SelectComponent as Select } from "screens/perfilAutonomo/components/SelectComponent";
import { MdOutlineRefresh } from "react-icons/md";
import { TextInput } from "screens/perfilAutonomo/components/TextInput";
import { BsTrash3Fill } from "react-icons/bs";
import { debounce, fName, fNO, searchCep } from "screens/perfilAutonomo/utils";
import { Tooltip } from "@mui/material";
import { Loading } from "screens/perfilAutonomo/components/Loading";
import { toast } from "react-toastify";
import { SearchBar } from "screens/perfilAutonomo/components/SeachBar";
import { getTorresV1 } from "services/api";
import { tooltipStyle } from "screens/oportunidadesDetail/components/historicoCard/utils";
import * as S from "./style";
import { defaultEmpreendimentoData } from "./utils";
import { fetchRevendaRegiao } from "../api/postRevendaRegiaoListar";
import { postEmpreendimentoRevendaCadastrar } from "../api/postEmpreendimentoRevendaCadastrar";
import { getProdutosDetalhesV1 } from "../api/getProdutosDetalhesV1";
import { fetchImobiliariasListar } from "../api/postImobiliariasListar";
import { putEmpreendimentoRevenda } from "../api/putEmpreendimentoRevenda";
import { fetchProdutosRevenda } from "../api/getListarProdutoRevenda";

const sharedStyle = {
  border: "none",
  height: 44,
  maxWidth: 44,
  width: 44,
};

export const NovoEmpreendimentoModal = ({
  open,
  edit,
  refetch,
  authToken,
  onClose,
}: {
  open: boolean;
  edit?: any;
  refetch: () => void;
  authToken: string;
  onClose: () => void;
}) => {
  const [data, setData] = useState(defaultEmpreendimentoData);
  const [is, setIs] = useState({
    refreshing: false,
    searchingCep: false,
    saving: false,
  });

  const { data: regiaoOptions, isLoading: loadingRegiao } = fetchRevendaRegiao(
    authToken,
    open
  );
  const { data: produtosOptions, isLoading: loadingProdutos } =
    fetchProdutosRevenda(open);
  const { data: imobiliariasOptions, isLoading: loadingImobiliarias } =
    fetchImobiliariasListar({ enabled: open, authToken });

  const isLoading = loadingRegiao || loadingProdutos || loadingImobiliarias;

  useEffect(() => {
    if (edit && open && !isLoading) {
      handleFillEdit();
    }
  }, [edit, open, isLoading]);

  const sumData = (id?: number | string) => {
    if (data?.torres?.filter((item) => !item.podeExcluir)?.length >= 10 && !id)
      return;

    setData((prev) => {
      if (id) {
        return {
          ...prev,
          torres: prev.torres.filter((item) => item.id !== id),
        };
      }

      return {
        ...prev,
        torres: [
          ...prev.torres,
          { id: Date.now(), descricao: "", podeExcluir: true },
        ],
      };
    });
  };

  const handleFillEdit = () => {
    setData((prev) => ({
      ...prev,
      idEmpreendimentoCRM: edit?.idEmpreendimentoCRM,
      nome: edit?.nome,
      cep: edit?.cep ?? "",
      logradouro: edit?.logradouro ?? "",
      numero: edit?.numero ?? "",
      bairro: edit?.bairro ?? "",
      cidade: edit?.cidade ?? "",
      uf: edit?.uf ?? "",
      idRevendaRegiao: edit?.idRevendaRegiao ?? "",
      idsImobiliaria: edit?.imobiliarias
        ? edit?.imobiliarias?.map((item: any) => item?.id)
        : [],
      torres: edit?.revendaEmpreendimentoTorres
        ? edit?.revendaEmpreendimentoTorres
            ?.map((item: any) => ({
              id: item?.id,
              descricao: item?.descricao,
              podeExcluir: item?.podeExcluir,
            }))
            ?.sort((a: any, b: any) => a?.podeExcluir - b?.podeExcluir)
        : prev.torres,
    }));
  };

  const handleFill = async (info: any) => {
    const { nomeEmpreendimento, localizacao, idEmpreendimento } = info || {};

    const {
      cep,
      endereco: logradouro,
      numero,
      bairro,
      cidade,
      estado: uf,
    } = localizacao || {};

    const initialTorres =
      data?.torres?.filter((item) => !item.podeExcluir) ?? [];

    const updatedData = {
      nome: nomeEmpreendimento,
      cep: cep ? fNO(cep) : "",
      logradouro,
      numero: numero ? fNO(numero) : "",
      bairro,
      cidade,
      uf,
      torres: initialTorres,
    };

    setData((prev) => ({ ...prev, ...updatedData }));

    try {
      const { success, data: fetchedTorres } = await getTorresV1(
        idEmpreendimento
      );

      if (!success) throw new Error();

      const newTorres =
        fetchedTorres
          ?.filter(
            (item: any) =>
              !initialTorres?.some(
                (existing) => existing?.descricao?.trim() === item?.nome?.trim()
              )
          )
          ?.map((item: any) => ({
            id: Math.floor(Math.random() * 1e13),
            descricao: item?.nome?.trim(),
            podeExcluir: item?.podeExluir !== false,
          })) ?? [];

      const mergedTorres = [...initialTorres, ...newTorres]?.sort(
        (a, b) => a.podeExcluir - b.podeExcluir
      );

      setData((prev) => ({ ...prev, torres: mergedTorres }));
    } catch (error) {
      console.error(error);
      toast.info("Não foi possível encontrar os dados das torres", {
        autoClose: 3000,
      });
    }
  };

  const cep_ = useCallback(
    debounce((cepSearch_) => {
      setIs((prev) => ({ ...prev, searchingCep: true }));

      searchCep(cepSearch_)
        .then((res) => {
          if (res?.status === 200 && !res?.data?.erro) {
            setData((prev) => ({
              ...prev,
              logradouro: res?.data?.logradouro,
              bairro: res?.data?.bairro,
              cidade: res?.data?.localidade,
              uf: res?.data?.uf,
            }));
          } else throw new Error();
        })
        .catch(() => {
          toast.error(
            "Erro ao buscar CEP. Por favor, verifique o CEP digitado e tente novamente."
          );
        })
        .finally(() => {
          setIs((prev) => ({ ...prev, searchingCep: false }));
        });
    }, 1250),
    []
  );

  const _reset = (keepIdE?: boolean) =>
    setData({
      ...defaultEmpreendimentoData,
      idEmpreendimentoCRM: keepIdE ? data.idEmpreendimentoCRM : "",
    });

  const handleClose = () => {
    setTimeout(() => _reset(), 250);
    onClose();
  };

  const handleRefresh = () => {
    setIs((prev) => ({ ...prev, refreshing: true }));

    const idEmpreendimento = produtosOptions?.find(
      (item: any) => item?.idEmpreendimento365 === data.idEmpreendimentoCRM
    )?.idEmpreendimento365;

    getProdutosDetalhesV1(idEmpreendimento)
      .then(async ({ success, data }) => {
        if (success && data?.[0]) {
          await handleFill(data?.[0]);
        } else throw new Error();
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Não encontramos informações na base do CRM, por favor preencha manualmente"
        );
        _reset(true);
      })
      .finally(() => {
        setIs((prev) => ({ ...prev, refreshing: false }));
      });
  };

  const handleSubmit = () => {
    setIs((prev) => ({ ...prev, saving: true }));

    const { torres, ...d } = data;

    const body: any = {
      ...d,
      torres: torres
        .map((item) => ({
          ...item,
          id: typeof item?.id === "number" ? null : item?.id,
        }))
        .filter((item) => item?.descricao?.trim()?.length > 0),
      authToken,
    };

    if (edit) body.id = edit?.id;

    const fn = edit
      ? putEmpreendimentoRevenda
      : postEmpreendimentoRevendaCadastrar;

    fn(body)
      .then(({ success, notifications }) => {
        if (success) {
          toast.success(
            `Empreendimento ${edit ? "atualizado" : "cadastrado"} com sucesso`
          );
          handleClose();
          refetch();
        } else throw new Error(notifications?.[0]?.message ?? null);
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          error?.message
            ? `Erro: ${error?.message}`
            : `Erro ao ${edit ? "atualizar" : "cadastrar"} empreendimento`
        );
      })
      .finally(() => {
        setIs((prev) => ({ ...prev, saving: false }));
      });
  };

  const canSubmit = (): boolean => {
    const {
      nome,
      cep,
      logradouro,
      numero,
      bairro,
      cidade,
      uf,
      idRevendaRegiao,
      idsImobiliaria,
      torres,
    } = data;

    return (
      nome?.length >= 3 &&
      cep?.length >= 7 &&
      logradouro?.length >= 3 &&
      numero?.length >= 1 &&
      bairro?.length >= 2 &&
      cidade?.length >= 3 &&
      uf?.length >= 2 &&
      idRevendaRegiao?.length >= 1 &&
      idsImobiliaria?.length >= 1 &&
      torres?.length >= 1
    );
  };

  return (
    <S.DialogContainer open={open} onClose={handleClose} maxWidth="md">
      <S.Container>
        <S.IconContainer>
          <div className="icon-wrapper">
            <RiBuilding2Fill color="#333" />
          </div>
          <h1 className="title center">{"Cadastrar Empreendimento"}</h1>
          <IoClose size={26} className="exit" onClick={handleClose} />
        </S.IconContainer>

        <S.Form>
          <div className="align-end">
            <S.Field>
              <p>{"Empreendimento CRM"}</p>
              <SelectComponent
                data={
                  produtosOptions?.map((item: any) => ({
                    label: item?.nomeEmpreendimento,
                    value: item?.idEmpreendimento365,
                  })) ?? []
                }
                onChange={(e: { label: string; value: string }) => {
                  setData((prev) => ({
                    ...prev,
                    idEmpreendimentoCRM: e?.value,
                  }));
                }}
                value={
                  produtosOptions
                    ?.map((item: any) => ({
                      label: item?.nomeEmpreendimento,
                      value: item?.idEmpreendimento365,
                    }))
                    ?.find(
                      (item: any) => item?.value === data?.idEmpreendimentoCRM
                    ) ?? ""
                }
                disabled={loadingProdutos}
                borderRadius="8px"
              />
            </S.Field>
            <Tooltip title="Buscar dados" placement="top" arrow>
              <div>
                <SecondaryButton
                  content={
                    is.refreshing ? (
                      <Loading size={16} color="#2196F3" />
                    ) : (
                      <MdOutlineRefresh color="#2196F3" size={20} />
                    )
                  }
                  onClick={handleRefresh}
                  disabled={is.refreshing || !data.idEmpreendimentoCRM}
                  style={{ width: 44 }}
                />
              </div>
            </Tooltip>
          </div>

          <S.Field>
            <p>
              {"Nome do Empreendimento "}
              <span>{"*"}</span>
            </p>
            <TextInput
              onChange={(val) => {
                setData((prev) => ({ ...prev, nome: val }));
              }}
              value={data.nome}
            />
          </S.Field>

          <S.Row template="2fr 7fr 1fr">
            <S.Field>
              <p>
                {"CEP "}
                <span>{"*"}</span>
              </p>
              <SearchBar
                placeholder="00000000"
                searchIcon="right"
                valueSearch={data.cep}
                onChangeSearch={(val) => {
                  const v = fNO(val);
                  setData((prev) => ({ ...prev, cep: v }));
                  if (v?.length < 8) return;
                  cep_(v);
                }}
                isLoading={is.searchingCep}
                isError={data?.cep?.length > 0 && data?.cep?.length < 8}
              />
            </S.Field>
            <S.Field>
              <p>
                {"Endereço "}
                <span>{"*"}</span>
              </p>
              <TextInput
                onChange={(val) => {
                  setData((prev) => ({ ...prev, logradouro: val }));
                }}
                value={data.logradouro}
              />
            </S.Field>
            <S.Field>
              <p>
                {"Número "}
                <span>{"*"}</span>
              </p>
              <TextInput
                onChange={(val) => {
                  setData((prev) => ({ ...prev, numero: fNO(val) }));
                }}
                value={data.numero}
              />
            </S.Field>
          </S.Row>

          <S.Row template="1fr 1fr 1fr">
            <S.Field>
              <p>
                {"Bairro "}
                <span>{"*"}</span>
              </p>
              <TextInput
                onChange={(val) => {
                  setData((prev) => ({ ...prev, bairro: val }));
                }}
                value={data.bairro}
              />
            </S.Field>
            <S.Field>
              <p>
                {"Cidade "}
                <span>{"*"}</span>
              </p>
              <TextInput
                onChange={(val) => {
                  setData((prev) => ({ ...prev, cidade: fName(val) }));
                }}
                value={data.cidade}
              />
            </S.Field>
            <S.Field>
              <p>
                {"Estado "}
                <span>{"*"}</span>
              </p>
              <TextInput
                onChange={(val) => {
                  setData((prev) => ({ ...prev, uf: fName(val) }));
                }}
                value={data.uf}
              />
            </S.Field>
          </S.Row>

          <S.Row template="1fr 1fr 1fr">
            <S.Field>
              <p>
                {"Região "}
                <span>{"*"}</span>
              </p>
              <SelectComponent
                data={
                  regiaoOptions?.map((item: any) => ({
                    label: item?.nome,
                    value: item?.id,
                  })) ?? []
                }
                onChange={(e: { label: string; value: string }) => {
                  setData((prev) => ({ ...prev, idRevendaRegiao: e?.value }));
                }}
                value={regiaoOptions
                  ?.map((item: any) => ({
                    label: item?.nome,
                    value: item?.id,
                  }))
                  ?.find((item: any) => item?.value === data.idRevendaRegiao)}
                disabled={loadingRegiao}
                borderRadius="8px"
              />
            </S.Field>
            <S.Field>
              <p>
                {"Imobiliária(s) "}
                <span>{"*"}</span>
              </p>
              <Select
                data={imobiliariasOptions?.map((item: any) => ({
                  label: item?.nome,
                  value: item?.id,
                }))}
                onChange={(val: string[]) => {
                  setData((prev) => ({ ...prev, idsImobiliaria: val }));
                }}
                value={data.idsImobiliaria}
                placeholder={""}
                disabled={loadingImobiliarias}
                multiple
                clearIcon
                renderLabel
              />
            </S.Field>
            <div id="dummy" />
          </S.Row>

          <S.Divider />

          <h2 style={{ fontSize: 18 }}>{"Torre"}</h2>

          <S.Row template="repeat(2, 1fr)">
            {data?.torres?.map((item, index) => {
              const validTorres = data?.torres?.filter(
                (t) => t?.podeExcluir !== false
              );
              const isLastValid =
                (validTorres?.length > 0 &&
                  validTorres[validTorres?.length - 1]?.id === item?.id) ||
                validTorres?.length === 0;

              return (
                <div className="align-end" key={item.id}>
                  <S.Field>
                    <p>
                      {"Nome da torre "}
                      <span>{"*"}</span>
                    </p>
                    <TextInput
                      onChange={(val: string) => {
                        setData((prev) => ({
                          ...prev,
                          torres: prev.torres.map((item_) =>
                            item_.id === item.id
                              ? { ...item_, descricao: val }
                              : item_
                          ),
                        }));
                      }}
                      value={item?.descricao}
                      placeholder="Nomes em branco serão ignorados"
                      disabled={is.refreshing}
                    />
                  </S.Field>

                  {isLastValid && validTorres?.length < 10 && (
                    <div>
                      <DefaultButton
                        content={<RiAddFill size={22} />}
                        onClick={() => sumData()}
                        style={{
                          backgroundColor: "#F2F4F8",
                          ...sharedStyle,
                        }}
                        disabled={is.refreshing}
                      />
                    </div>
                  )}

                  <Tooltip
                    title={
                      item?.podeExcluir === false
                        ? "Essa torre não pode ser excluída pois tem vínculo com uma unidade"
                        : ""
                    }
                    placement="top"
                    arrow
                    componentsProps={tooltipStyle.error}
                  >
                    <div>
                      <SecondaryButton
                        content={<BsTrash3Fill color={"#F43636"} size={22} />}
                        onClick={() => sumData(item.id)}
                        style={sharedStyle}
                        color="error"
                        disabled={
                          is.refreshing ||
                          (data?.torres?.length === 1 && index === 0) ||
                          item?.podeExcluir === false
                        }
                      />
                    </div>
                  </Tooltip>
                </div>
              );
            })}
          </S.Row>

          <div style={{ marginTop: 20 }} />
        </S.Form>

        <S.Row>
          <div id="dummy" />
          <S.Row>
            <SecondaryButton content={"Cancelar"} onClick={handleClose} />
            <PrimaryButton
              content={
                is.saving ? <Loading size={18} color="white" /> : "Salvar"
              }
              onClick={handleSubmit}
              disabled={is.saving || !canSubmit()}
            />
          </S.Row>
        </S.Row>
      </S.Container>
    </S.DialogContainer>
  );
};
